<template>
  <Catalog
    title="Тег"
    name-label="Название тега"
    submit-error="Укажите название тега."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  >
    <template #optional-skeleton>
      <b-row class="mb-2">
        <b-col cols="8">
          <b-skeleton width="32%" height="20%" class="mb-2"/>
          <b-skeleton type="input" width="100%" height="43%"/>
        </b-col>
        <b-col cols="4">
          <b-skeleton width="16%" height="20%" class="mb-2"/>
          <b-skeleton type="input" width="100%" height="43%"/>
        </b-col>
      </b-row>
    </template>

    <template #optional-fields="{ model }">
      <b-row>
        <b-col cols="8">
          <b-form-group id="group-description" label="Описание">
            <b-form-input
              id="input-description"
              type="text"
              size="sm"
              v-model="model.description"
              trim
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group id="group-color" label="Цвет">
            <b-input-group size="sm">
              <template #prepend>
                <div id="color-picker" :style="colorPreviewStyle(model.color || '#FFFFFF')"/>
              </template>
              <b-form-input
                id="input-color"
                :value="model.color"
                @update="value => model.color = value.toUpperCase()"
                placeholder="#RRGGBB"
              />
            </b-input-group>
            <b-popover target="color-picker" triggers="click" placement="bottom">
              <Compact :value="model.color || '#FFFFFF'" @input="newColor => $set(model, 'color', newColor.hex)"/>
            </b-popover>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </Catalog>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import { Compact } from 'vue-color';
    import Catalog from "../Catalog.vue";

export default {
  name: "RecruitTag",
  components: { Catalog, Compact },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getRecruitTagById(id);
    },
    async putData(data) {
      return await this.putRecruitTag(data)
    },
    async postData(data) {
      return await this.postRecruitTag(data)
    },
    colorPreviewStyle(color) {
      return {
        width: '38px',
        height: '31px',
        backgroundColor: color || '#FFFFFF',
        border: '1px solid #ced4da',
        borderRight: 'none',
        borderTopLeftRadius: '0.25rem',
        borderBottomLeftRadius: '0.25rem',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease'
      };
    }
  }
}
</script>

<style scoped>
</style>





// WEBPACK FOOTER //
// src/components/Catalogs/RecruitTags/RecruitTag.vue